import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Airplay = function Airplay(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 18c-1.6568 0-3-1.3431-3-3V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 3 5.1198 3 6.8 3h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 5.2798 22 6.1198 22 7.8V15c0 1.6569-1.3431 3-3 3M8.708 21h6.584c.5448 0 .8173 0 .9547-.1111a.5.5 0 0 0 .1857-.3964c-.0026-.1768-.177-.3861-.5259-.8046l-3.2919-3.9504c-.2111-.2533-.3166-.3799-.443-.4261a.5.5 0 0 0-.3432 0c-.1264.0462-.2319.1728-.443.4261l-3.292 3.9504c-.3488.4185-.5232.6278-.5258.8046a.5.5 0 0 0 .1857.3964C7.8907 21 8.1632 21 8.708 21"
    })
  }));
};
export default Airplay;